/// <reference path="../typings/index.d.ts" />
/// <reference path="Grecaptcha.d.ts" />
declare var grecaptcha: any;

namespace App {
    export class Grecaptcha implements IGrecaptcha {

        public inicializar(): void {
            let grecaptchaKeyMeta = document.querySelector("meta[name='grecaptcha-key']");
            let grecaptchaKey = grecaptchaKeyMeta.getAttribute("content");

            grecaptcha.ready(function() {
                let forms = document.querySelectorAll('form[data-grecaptcha-action]');

                Array.from(forms).forEach(function(form: any) {
                    form.onsubmit = (e: any) => {
                        e.preventDefault();
                        let grecaptchaAction = form.getAttribute('data-grecaptcha-action');
                        grecaptcha.execute(grecaptchaKey, { action: grecaptchaAction })
                            .then((token: any) => {
                                var input = document.createElement('input');
                                input.type = 'hidden';
                                input.name = 'grecaptcha';
                                input.value = token;

                                form.append(input);
                                form.submit();
                            });
                    }
                });
            });
        }
    }
}
